import qs from 'qs'
import { get } from 'lodash-es'
export function windowOpenSelf(url: string): any {
  return window.open(url, '_self')
}

export function windowLocationReplace(url: string): any {
  return window.location.replace(url)
}

export function getSearchParams(): any {
  return qs.parse(get(window, 'location.search', '').replace('?', ''))
}
